// types
import { ActStatus } from '../../../../@types';

// l18n
import { TFunction } from 'i18next';

// mui
import { Typography } from '@mui/material';

// table
import { TableHeader } from '../../../ui/Table/Table';

// ui
import { Time } from '../../../ui/Time/Time';
import { ChipStatus } from '../../../ui/ChipStatus/ChipStatus';

// props
export interface GetHeadersProps {
	t: TFunction<'translation', undefined>;
}

export const getHeaders = ({ t }: GetHeadersProps): TableHeader[] => {
	return [
		{
			label: t('name'),
			render: (name: string) => {
				return <Typography fontWeight={600}>{name}</Typography>;
			},
			value: 'name',
		},
		{
			label: t('startDate'),
			render: (dateStart: string) => {
				return <Time date={new Date(dateStart)} />;
			},
			value: 'dateStart',
		},
		{
			label: t('endDate'),
			render: (dateEnd: string) => {
				return <Time date={new Date(dateEnd)} />;
			},
			value: 'dateEnd',
		},
		{
			label: t('status'),
			render: (status: ActStatus) => {
				return <ChipStatus status={status} />;
			},
			value: 'status',
		},
	];
};
